var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "icon", class: { "icon--circle": _vm.hasCircle === true } },
    [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: _vm.width,
            height: _vm.height,
            viewBox: _vm.viewBox,
            "aria-labelledby": _vm.iconName,
            role: "presentation"
          }
        },
        [
          _c("title", { attrs: { id: _vm.iconName, lang: "en" } }, [
            _vm._v(_vm._s(_vm.iconName) + " icon")
          ]),
          _vm._v(" "),
          _c(
            "g",
            { class: "icon__container " + _vm.iconColor },
            [_vm._t("default")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }